export default __webpack_public_path__ + "static/media/filter-view-gallery.97924e71.svg";